export default __webpack_public_path__ + "images/d0ca145ee2cf6c9f064106a4e7e1150c.svg";